export const REWARD_TYPES = {
  XOXO_POINTS: 1,
  XOXO_CODE: 2,
  XOXO_LINK: 3,
  PLUM_PRO: 4,
};
// XOXO CODE
//const bulkSampleLink = "https://xoxoday-testing.s3.us-west-2.amazonaws.com/vouchers/bulk_xoxocode_template2.csv"
//const bulkSampleLink = "https://xoxoday-images.s3.amazonaws.com/plum/pdf/bulk_xoxocode_template3.csv"
//const bulkSampleLink = "https://xoxoday-testing.s3.us-west-2.amazonaws.com/vouchers/bulk_xoxocode_template1.csv"

export const XOXO_CODE_SAMPLE_BULK_FILE =
  "https://xoxoday-testing.s3.amazonaws.com/vouchers/bulk_xoxocode_template5.csv";

export const XOXO_POINT_SAMPLE_BULK_FILE =
  "https://xoxoday-testing.s3.amazonaws.com/vouchers/bulk_xoxopoint_template5.csv";

export const PLUM_PRO_SAMPLE_BULK_FILE =
  "http://xoxoday-testing.s3.amazonaws.com/plum/pdf/products_bulk_upload.xls";

export const XOXO_LINK_SAMPLE_BULK_FILE = "";

export const BULK_COLUMN_DEF = [
  [
    "name",
    "email",
    "country",
    "mobile",
    "amount_points",
    "schedulerPoints",
    "note",
    "message",
  ],
  [
    "name",
    "email",
    "country",
    "mobile",
    "amount",
    "quantity",
    "schedulerPoints",
    "note",
    "message",
  ],
  ["name", "email", "country", "mobile", "message", 'note'],
  [
    "name",
    "email",
    "country",
    "mobile",
    "product_id",
    "product_name",
    "amount_plumpro",
    "quantity_plumpro",
    "note",
    "po_number",
    "message",
  ],
];

export const FILE_UPLOAD_ERROR_CODE = ["PBB10015"];

export const BULK_UPLOAD_SAMPLE_FILE_DATA = [
  XOXO_POINT_SAMPLE_BULK_FILE,
  XOXO_CODE_SAMPLE_BULK_FILE,
  XOXO_LINK_SAMPLE_BULK_FILE,
  PLUM_PRO_SAMPLE_BULK_FILE,
];
export const XOXOLINK_BULK_SAMPLE_ONLY_EMAIL =
  "https://xoxoday-images.s3.amazonaws.com/plum/pdf/bulk_xoxolink_email_template.csv";

export const XOXOLINK_BULK_SAMPLE_ONLY_MESSAGE =
  "https://xoxoday-images.s3.amazonaws.com/plum/pdf/bulk_xoxolink_sms_template.csv";

export const XOXOLINK_BULK_SAMPLE_BOTH_EMAIL_MESSAGE =
  "https://xoxoday-images.s3.amazonaws.com/plum/pdf/bulk_xoxolink_email_sms_template.csv";

const FORM_DATA = {
  mail_details: "",
  sms_details: "",
  reward_type: 0,
  skip_filename_check: 0,
  campaign_id: 0,
};

export const BATCH_STATUS_POLLING = {
  BATCH_CREATED: "BATCH_CREATED",
  VALIDATION_IN_PROGRESS: "VALIDATION_IN_PROGRESS",
  VALIDATION_FAILURE: "VALIDATION_FAILURE",
  VALIDATION_SUCCESS: "VALIDATION_SUCCESS",
  PROCESSING: "PROCESSING",
  COMPLETE: "COMPLETE",
  FAILURE: "FAILURE",
  CANCELLED: "CANCELLED",
  PARTIALLY_PROCESSED: "PARTIALLY_PROCESSED",
};

export const POLLING_STATUS_IMAGES = {
  VALIDATION_SUCCESS: "/admin/img/icons/Hourglass.svg",
  PROCESSING: "/admin/img/icons/Hourglass.svg",
  COMPLETE: "/admin/img/icons/success_upload.svg",
  FAILURE: "/admin/img/icons/fail.svg",
  CANCELLED: "/admin/img/icons/Icon-warning.svg",
  VALIDATION_SUCCESS_2: "/admin/img/icons/success_upload.svg",
  COMPLETE_2: "/admin/img/icons/Icon-warning.svg",
};

export const DEAFULT_PROCESSING_STATUS = {
  INACTIVE: 0,
  STARTED: 1,
  STATUS_SUCCESS: 2,
  STATUS_FAILURE: 3,
  PROCESSING_STARTED: 4,
  PROCESSING_FINISHED: 5,
};

const BULK_FILE_BATCH_STATUS = {
  currentAmount: 0,
  final_file_path: "",
  scheduledAmount: 0,
  status: "",
  total_rows: 0,
  total_validation_error: 0,
  insufficient_fund: 0,
  insufficient_threshold: 0,
  is_scheduler: 0,
  currentCount: 0,
  scheduledCount: 0,
  total_processed: 0,
  total_success: 0,
};

export const DEFAULT_BULK_DATA = {
  uploading: false,
  fileName: "",
  uploadFileMsg: "",
  activeScreen: 0,
  batchId: "",
  batchProcessData: BULK_FILE_BATCH_STATUS,
  processing: DEAFULT_PROCESSING_STATUS.INACTIVE,
  showBulkPayment: false,
  skipFileCheck: false,
  uploadFileErr: "",
  cxmlData: "",
};

export const POLLING_DATA_FILE = {
  batch_id: "",
  reward_type: 0,
  fileName: "",
  // status : BULK_FILE_BATCH_STATUS
};

export const DEFAULT_APP_BULK_PROCESS_DATA = [];

export const DEAFUALT_APP_BULK_PROCESS_STATUS = [];
